import { motion } from "framer-motion";
import { JOURNEY } from "@/lib/data";
import { fadeUp, inViewOnce } from "@/lib/motion";

export default function Journey() {
  return (
    <section
      id="curriculum"
      data-testid="journey-section"
      className="relative py-24 md:py-40 border-t border-[color:var(--line)] bg-[color:var(--bone-2)]"
    >
      <div className="mx-auto max-w-[1360px] px-5 md:px-8">
        <div className="flex items-center justify-between mb-14 md:mb-20">
          <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[color:var(--ink-3)]">
            Ch. 02 — Curriculum
          </span>
          <span className="font-mono text-[11px] tabular-nums text-[color:var(--ink-3)]">
            §002 / 010
          </span>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={inViewOnce}
          transition={{ duration: 0.9 }}
          className="font-serif text-[42px] sm:text-[62px] md:text-[80px] leading-[0.98] tracking-[-0.03em] font-medium max-w-[900px]"
        >
          What you will{" "}
          <em className="italic font-normal text-[color:var(--copper-2)]">
            learn.
          </em>
        </motion.h2>

        <motion.ol
          initial="hidden"
          whileInView="show"
          viewport={inViewOnce}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.08 } },
          }}
          className="mt-16 md:mt-24 divide-y divide-[color:var(--line-strong)] border-t border-b border-[color:var(--line-strong)]"
        >
          {JOURNEY.map((stage) => (
            <motion.li
              key={stage.n}
              variants={fadeUp}
              data-testid={`journey-stage-${stage.n}`}
              className="group relative grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 items-baseline hover:bg-[color:var(--bone)] transition-colors duration-500 -mx-3 md:-mx-6 px-3 md:px-6"
            >
              <div className="col-span-3 md:col-span-2">
                <span className="chapter-num text-[56px] md:text-[88px]">
                  {stage.n}
                </span>
              </div>
              <div className="col-span-9 md:col-span-4 lg:col-span-5">
                <h3 className="font-serif text-[24px] md:text-[36px] leading-[1.05] font-medium text-[color:var(--ink)] tracking-[-0.02em]">
                  {stage.label}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-5">
                <p className="text-[14px] md:text-[16px] leading-[1.6] text-[color:var(--ink-2)] text-pretty">
                  {stage.body}
                </p>
              </div>

              {/* animated indicator */}
              <span
                aria-hidden="true"
                className="absolute right-0 top-1/2 -translate-y-1/2 w-0 group-hover:w-8 h-px bg-[color:var(--copper)] transition-all duration-500"
              />
            </motion.li>
          ))}
        </motion.ol>

        <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.2em] text-[color:var(--ink-3)]">
          Source: Official curriculum · Packt Publishing · 2026
        </p>
      </div>
    </section>
  );
}
